export * from './case.service';
import { CaseService } from './case.service';
export * from './caseDashboard.service';
import { CaseDashboardService } from './caseDashboard.service';
export * from './claim.service';
import { ClaimService } from './claim.service';
export * from './claimAttribute.service';
import { ClaimAttributeService } from './claimAttribute.service';
export * from './claimAttributeValue.service';
import { ClaimAttributeValueService } from './claimAttributeValue.service';
export * from './claimDocument.service';
import { ClaimDocumentService } from './claimDocument.service';
export * from './claimTemplate.service';
import { ClaimTemplateService } from './claimTemplate.service';
export * from './client.service';
import { ClientService } from './client.service';
export * from './clientRegistration.service';
import { ClientRegistrationService } from './clientRegistration.service';
export * from './contract.service';
import { ContractService } from './contract.service';
export * from './contractGroup.service';
import { ContractGroupService } from './contractGroup.service';
export * from './contractTemplate.service';
import { ContractTemplateService } from './contractTemplate.service';
export * from './emailTemplate.service';
import { EmailTemplateService } from './emailTemplate.service';
export * from './emailing.service';
import { EmailingService } from './emailing.service';
export * from './evidenceDocument.service';
import { EvidenceDocumentService } from './evidenceDocument.service';
export * from './exports.service';
import { ExportsService } from './exports.service';
export * from './health.service';
import { HealthService } from './health.service';
export * from './localization.service';
import { LocalizationService } from './localization.service';
export * from './notifications.service';
import { NotificationsService } from './notifications.service';
export * from './ocr.service';
import { OcrService } from './ocr.service';
export * from './platformLogging.service';
import { PlatformLoggingService } from './platformLogging.service';
export * from './platformUser.service';
import { PlatformUserService } from './platformUser.service';
export * from './reviewMessage.service';
import { ReviewMessageService } from './reviewMessage.service';
export * from './sendGridConfiguration.service';
import { SendGridConfigurationService } from './sendGridConfiguration.service';
export * from './support.service';
import { SupportService } from './support.service';
export const APIS = [CaseService, CaseDashboardService, ClaimService, ClaimAttributeService, ClaimAttributeValueService, ClaimDocumentService, ClaimTemplateService, ClientService, ClientRegistrationService, ContractService, ContractGroupService, ContractTemplateService, EmailTemplateService, EmailingService, EvidenceDocumentService, ExportsService, HealthService, LocalizationService, NotificationsService, OcrService, PlatformLoggingService, PlatformUserService, ReviewMessageService, SendGridConfigurationService, SupportService];
